"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMonth = exports.StyledMonthsContainer = exports.StyledHeaderContainer = exports.StyledDivider = exports.StyledContainer = exports.StyledCalendar = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _attachThemeAttrs = _interopRequireDefault(require("../../../../styles/helpers/attachThemeAttrs"));

var _fontSizes = require("../../../../styles/fontSizes");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    color: ", ";\n    text-transform: capitalize;\n    font-weight: 500;\n    margin: 0 1rem 0 0;\n    padding: 0;\n    box-sizing: border-box;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    justify-content: stretch;\n    align-items: center;\n    flex-grow: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 1;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    min-width: 2.5rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: start;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    flex: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCalendar = _styledComponents["default"].div(_templateObject());

exports.StyledCalendar = StyledCalendar;

var StyledContainer = _styledComponents["default"].div(_templateObject2());

exports.StyledContainer = StyledContainer;

var StyledDivider = _styledComponents["default"].div(_templateObject3());

exports.StyledDivider = StyledDivider;

var StyledHeaderContainer = _styledComponents["default"].div(_templateObject4());

exports.StyledHeaderContainer = StyledHeaderContainer;

var StyledMonthsContainer = _styledComponents["default"].div(_templateObject5());

exports.StyledMonthsContainer = StyledMonthsContainer;
var StyledMonth = (0, _attachThemeAttrs["default"])(_styledComponents["default"].h3)(_templateObject6(), _fontSizes.FONT_SIZE_HEADING_MEDIUM, function (props) {
  return props.palette.text.main;
});
exports.StyledMonth = StyledMonth;